import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import InsuranceColumn from '../../columns/insurance-column';
import Global from '../../../store/global-selectors';
import { messages } from '../messages';
import { calculateTotalInsuredValue } from '../../../services/insurance-service';
import { USD } from '../../../constants/currency-codes';

const InsuranceColumnContainer = ({ fulfillmentId }) => {
  const {
    packages,
    labelFulfillment = {},
    insuranceBookingId,
    insuranceClaimInitiationUrl,
    fulfillmentPlanId,
  } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const { insuranceProviderId, insuranceTransactionId } = labelFulfillment;
  const sellerCurrencyCode = useSelector(Global.selectSellerDefaultCurrency) || USD;

  const data = useMemo(() => {
    const insuredAmount = calculateTotalInsuredValue(packages, insuranceProviderId, sellerCurrencyCode);
    return {
      fulfillmentPlanId,
      insuredAmount,
      insuranceProviderId,
      insuranceTransactionId,
      insuranceBookingId,
      insuranceClaimInitiationUrl,
    };
  }, [
    packages,
    fulfillmentPlanId,
    insuranceProviderId,
    sellerCurrencyCode,
    insuranceTransactionId,
    insuranceBookingId,
    insuranceClaimInitiationUrl,
  ]);

  return <InsuranceColumn data={data} />;
};

InsuranceColumnContainer.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const Insurance = {
  getMessageDescriptor: () => messages.insurance,
  id: 'insurance',

  render: (data) => {
    if (!data) {
      return '';
    }
    return <InsuranceColumnContainer fulfillmentId={data.id} />;
  },
};
